var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m11.9488 13.8488 4.6512 4.6512 2.4-2.4-4.6512-4.6512m1.0512-3.7488c0 3.9765-3.2235 7.2-7.2 7.2-3.97645 0-7.2-3.2235-7.2-7.2 0-3.97645 3.22355-7.2 7.2-7.2 3.9765 0 7.2 3.22355 7.2 7.2z","stroke":"#212121","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeOpacity":".2"}));
}

SearchIconInline.defaultProps = {"fill":"none","height":"19","viewBox":"0 0 20 19","width":"20"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
